import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Admin";

export const SIGN_IN_ENDPOINT = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Login`, options);

export const FORGET_PASSWORD_ENDPOINT = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ForgetPassword`, options);
